export default {
  customCodeInEditMode: [],
  widgetsInEditMode: [],
  computedPropsInEditMode: []
}


// WEBPACK FOOTER //
// ./src/store/states/editable.js